import dayjs from 'dayjs'
export const columns = [
  {
    title: 'page_my_document_filenm',
    dataIndex: 'originalFilename',
    key: 'originalFilename',
    ellipsis: true,
    width: 200
  },
  {
    title: 'page_my_document_size',
    dataIndex: 'contentLength',
    key: 'contentLength',
    width: 120,
    ellipsis: true,
    customRender: text => {
      let size
      if (text) {
        text = Number(text)
        if (text > 1024 && text < 1048576) {
          size = (text / 1024).toFixed(1) + 'KB'
        } else if (text > 1048576) {
          size = (text / 1048576).toFixed(1) + 'MB'
        } else {
          size = text.toFixed(1) + 'B'
        }
        return size
      }
    }
  },
  {
    title: 'page_transport_directory_upload_time',
    dataIndex: 'lastModified',
    key: 'lastModified',
    ellipsis: true,
    customRender: text => {
      return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  }
]
